<template>
  <div class="success text-center" v-if="isSuccess">
    <img class="back-img" src='../../assets/img/nazuna-wink.png'>
    <img class="success-img" src="../../assets/img/success-icon.png">
    <p class="success-title">Payment success!!</p>
    <p class="success-text">Please wait for shipping</p>
    <btn type="primary" size="normal" label="back" @click="back"></btn>
  </div>
</template>

<script>
import Btn from '../../components/Button.vue'
import axios from 'axios'

export default {
  name: 'paymentSuccess',

  components: {
    Btn
  },

  data() {
    return {
      isSuccess: false,
    };
  },

  mounted() {
    axios.get(`private/payment_data/${localStorage.getItem('nerzEX_payment_data_id')}`)
    .then(data => {
      if(data.data.payment.token === localStorage.getItem('nerzEX_paymentid')) {
        const postData = {
          buyer_id: data.data.payment.buyer_id,
          request_id: data.data.payment.request_id,
          idea_id: data.data.payment.idea_id,
          phase: 4,
          saler_id: data.data.payment.saler_id,
          type: 0,
        };
        axios.post('private/trade', postData)
        .then((data) => {
          this.requestDone()
        }).catch((err) => {
          console.log(err)
        });
      } else {
        alert("invalid access")
        this.$router.push('/')
      }
    }).catch(err => {
        alert("invalid access")
        this.$router.push('/')
    })
  },

  methods: {
    back() {
      this.$router.push(`/request/${this.$route.params.id}`)
    },
    requestDone() {
      axios.put(`/private/request/${this.$route.params.id}`, {is_done: 1})
      .then(data => {
        this.isSuccess = true
      }).catch(err => {
        console.log(err)
      })
    }
  }
}

</script>

<style scoped>
.success-title {
  margin-top: 30px;
  font-size: 20px;
  font-weight: bold;
}

.success-text {
  font-size: 15px;
}

.success {
  position: relative;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
  padding: 20px;
}
.success-img {
  margin-top: 20px;
  width: 40vw;
}

.back-img {
  width:  500px;
  position: absolute;
  top: 10%;
  left: 10%;
  opacity: 0.2;
  z-index: -1;
}

@media screen and (min-width: 800px){
  .success-img {
    width: 10vw;
  }
}
</style>
